<template>
	<div class="columns">
		<div class="column">
			<div class="list-title">
				{{ !selectedTab ? $t('statistics.events') : $t('statistics.inspections') }}
			</div>
			<BarChart
				v-if="!selectedTab"
				:key="$i18n.locale"
				:chartData="flawsDone"
				:chartData2="flawsUndone"
				:labels="labels"
				:categoryLabels="categoryLabels"
				:colors="colors"
			/>

			<div v-else class="list-container inner column">
				<div class="panel-list-header extra-narrow mobile_statistics">
					<div class="panel-header-item mobile_statistics__header">Namn</div>
					<div class="panel-header-item narrow">{{ $t('statistics.january') }}</div>
					<div class="panel-header-item narrow">{{ $t('statistics.february') }}</div>
					<div class="panel-header-item narrow">{{ $t('statistics.march') }}</div>
					<div class="panel-header-item narrow">{{ $t('statistics.april') }}</div>
					<div class="panel-header-item narrow">{{ $t('statistics.may') }}</div>
					<div class="panel-header-item narrow">{{ $t('statistics.june') }}</div>
					<div class="panel-header-item narrow">{{ $t('statistics.july') }}</div>
					<div class="panel-header-item narrow">{{ $t('statistics.august') }}</div>
					<div class="panel-header-item narrow">{{ $t('statistics.september') }}</div>
					<div class="panel-header-item narrow">{{ $t('statistics.october') }}</div>
					<div class="panel-header-item narrow">{{ $t('statistics.november') }}</div>
					<div class="panel-header-item narrow">{{ $t('statistics.december') }}</div>
				</div>
				<div
					class="panel-list extra-narrow"
					v-for="(round, index) in roundPlanningStatistics"
					:key="index"
				>
					<p class="panel-list-item mobile-data">
						{{ round.name }}
					</p>
					<div
						class="panel-circle mobile-data__list"
						v-for="(history, index) in round.roundHistoryStatistics"
						:key="index"
					>
						<i class="fas fa-circle" :class="getColor(history)"></i>
					</div>
				</div>
			</div>
		</div>
		<div class="column info" :class="{ mobile: isMobile }">
			<div class="list-title">{{ $t('statistics.info') }}</div>
			<div class="info-box">
				<div class="field">
					<label class="label">{{ $t('statistics.year_label') }}</label>
					<div class="control">
						<v-select
							class="panel-select year"
							:value="year"
							:options="years"
							:placeholder="$t('statistics.year_placeholder')"
							:allowEmpty="false"
							:internalSearch="true"
							:showLabels="false"
							@select="$emit('set-year', $event)"
						>
							<span slot="noResult">{{ $t('statistics.no_results') }}</span>
							<span
								slot="caret"
								slot-scope="{ toggle }"
								class="caret"
								@mousedown.prevent.stop="toggle()"
							><i class="fas fa-caret-down caret-inner"></i
							></span>
						</v-select>
					</div>
				</div>
				<div class="field">
					<div class="info-text-box">{{ infoBox }}</div>
				</div>
				<div class="tabs is-toggle is-fullwidth">
					<ul>
						<li
							:class="selectedTab == 0 ? 'is-active' : ''"
							@click="$emit('select-tab', 0)"
						>
							<a>
								<p>{{ $t('statistics.events') }}</p>
							</a>
						</li>
						<li
							:class="selectedTab == 1 ? 'is-active' : ''"
							@click="$emit('select-tab', 1)"
						>
							<a>
								<p>{{ $t('statistics.inspections') }}</p>
							</a>
						</li>
					</ul>
				</div>
			</div>
			<PieChart
				:key="$i18n.locale + '-' + selectedTab"
				:chartData="pieData"
				:labels="pieLabels"
				:colors="pieColors"
			/>
		</div>
	</div>
</template>

<script>
import BarChart from '@/components/BarChart';
import PieChart from '@/components/PieChart';

export default {
	name: 'LegacyStatisticsPanel',

	components: {
		BarChart,
		PieChart
	},

	props: {
		categoryLabels: {
			type: Array,
			default: () => []
		},
		colors: {
			type: Array,
			default: () => []
		},
		flawsDone: {
			type: Array,
			default: () => []
		},
		flawsUndone: {
			type: Array,
			default: () => []
		},
		getColor: {
			type: Function,
			required: true
		},
		infoBox: {
			type: String,
			default: ''
		},
		isMobile: {
			type: Boolean,
			default: false
		},
		labels: {
			type: Array,
			default: () => []
		},
		pieColors: {
			type: Array,
			default: () => []
		},
		pieData: {
			type: Array,
			default: () => []
		},
		pieLabels: {
			type: Array,
			default: () => []
		},
		roundPlanningStatistics: {
			type: Array,
			default: () => []
		},
		selectedTab: {
			type: Number,
			default: 0
		},
		year: {
			type: String,
			default: ''
		},
		years: {
			type: Array,
			default: () => []
		}
	}
};
</script>
